import styled from 'styled-components';

const getIcon = (color) => {
  const fillColor = encodeURIComponent(color);

  return `url("data:image/svg+xml;charset=utf-8,%3Csvg fill='${fillColor}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M17.4 6.6a2 2 0 00-2.8 0L12 9.2 9.4 6.6a2 2 0 10-2.8 2.8L9.2 12l-2.6 2.6a2 2 0 102.8 2.8l2.6-2.6 2.6 2.6a2 2 0 002.8 0c.8-.8.8-2 0-2.8L14.8 12l2.6-2.6c.8-.8.8-2 0-2.8z'/%3E%3C/svg%3E")`;
};

export const Overlay = styled.div`
  align-items: center;
  background-color: var(--theme-color-always-dark-overlay);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  padding: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`;

export const Wrapper = styled.div<{ fullScreen: boolean }>`
  width: ${(props) => (props.fullScreen ? 'calc(100vmin - 1rem)' : '500px')};

  @media (orientation: portrait) {
    width: ${(props) => (props.fullScreen ? 'calc(100vmin - 1rem)' : '500px')};
  }

  @media ${(props) => props.theme.breakpoints.md} {
    width: ${(props) => (props.fullScreen ? 'calc(100vmin - 4rem)' : '500px')};
  }
`;

export const ModalBox = styled.div`
  background: var(--theme-color-background);
  border: solid 4px #000;
  box-shadow: 4px 4px 0 0 black;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  padding: 1rem;
  padding-right: 4rem;
  position: relative;
  z-index: 2;

  &:before,
  &:after {
    background: var(--theme-color-section);
    content: ' ';
    height: 110px;
    left: 50%;
    position: absolute;
    top: -30px;
    width: 110%;
    z-index: -1;
  }

  &:before {
    transform: translateX(-50%) rotate(-4deg);
  }

  &:after {
    transform: translateX(-50%) rotate(4deg);
  }
`;

export const Body = styled.div`
  height: calc(100% - 132px);
  padding: 1rem;
  position: relative;
  width: 100%;
`;

export const CloseButton = styled.button`
  background: none no-repeat center center;
  background-image: ${(props) => getIcon(props.theme.colors?.text)};
  background-size: 34px 34px;
  border: 0;
  cursor: pointer;
  height: 40px;
  position: absolute;
  right: 1rem;
  width: 50px;

  &:hover {
    background-image: ${(props) => getIcon(props.theme.colors?.grey3)};
  }
`;

export const Title = styled.h1``;
